<template>
  <div>
    <select-date-header></select-date-header>
    <select-date-title-lea-abs
      :activeTab="activeTab"
    ></select-date-title-lea-abs>
    <select-date-content-appl
      @selectDate="selectDate"
      ref="selectDateContentAppl"
    ></select-date-content-appl>
  </div>
</template>
<script>
import SelectDateHeader from '@/components/application/form/SelectDateHeader.vue';
import SelectDateContentAppl from '@/components/application/form/SelectDateContentAppl.vue';
import SelectDateTitleLeaAbs from '@/components/application/form/SelectDateTitleLeaAbs.vue';

import { mapGetters, mapMutations } from 'vuex';

import routerNames from '@/const/routerConstants';
import applCdMixin from '@/mixins/applCdMixin.js';
import dayjs from 'dayjs';
import 'dayjs/locale/ko';
import {
  getRemainDaysBefore,
} from '@/api/workStatus';

dayjs.locale('ko');

/**
 * 시작일자 선택 뷰
 * 신청서 별 다음 페이지 분기
 * */
export default {
  mixins: [applCdMixin],

  data: () => ({
    startDateResetFlag: false,
  }),
  computed: {
    ...mapGetters('ELA', ['GET_DATE_TYPE', 'GET_OTWORK_APPL_GUBUN', 'GET_APPL_CD1', ]),
    ...mapGetters(['GET_LIMIT_TERM', 'GET_CA_DAYS', 'GET_APPL_TYPE', 'GET_PARLEV_RETURN_YMD', 'GET_ADD_LIMIT_TERM','GET_APPL_CD']),
    activeTab() {
      if ((this.isVacation || this.isReward) && this.GET_DATE_TYPE === 'D') {
        return 'S'; // 시작일자
      } else {
        return '날짜선택'; // 날짜선택
      }
    },
  },
  methods: {
    ...mapMutations('ELA', [
      'SET_APPL_YMD',
      'SET_APPL_YMD_WEEK',
      'SET_IN_OUT_YN',
      'SET_REST_HOUR',
      'SET_REQUEST_HOUR',
      'SET_S_YMD',
    ]),

    // 날짜 선택시
    async selectDate(sYmd) {
      if (this.isVacation || this.isReward) {
        this.nextStepVacation(sYmd);
      } else if (this.isOtWork) {
        // 초기화
        this.SET_IN_OUT_YN('Y');
        this.SET_REST_HOUR('0');
        this.SET_REQUEST_HOUR('0');
        this.$router.push(routerNames.ConfirmOtWorkTime); // 연장근무 시간확인 화면
      } else if (this.isSchedule) {
        await this.$store.dispatch('ELA/FETCH_WORK_ORG_TIME_LIST'); //근무유형 근무시간 조회
        this.$router.push(routerNames.SelectSchedule); // 근무스케줄 선택 화면
      } else if (this.isAttend) {
        this.$router.push(routerNames.SelectTime); // 출퇴근시간선택
      } else {
        // 신규 화면들인 경우(신청서들)
        let param = {
          sYmd: sYmd,
        }
        let response = await getRemainDaysBefore(param);

        if (this.GET_APPL_CD === '151') {
      this.$store.commit('SET_REMAIN_DAYS_BEFORE', Number(response.data.data.remainDaysBefore) + Number(this.GET_ADD_LIMIT_TERM));
      }else {
      this.$store.commit('SET_REMAIN_DAYS_BEFORE', parseInt(response.data.data.remainDaysBefore));
      }

        if (
          this.GET_LIMIT_TERM <= this.GET_CA_DAYS &&
          this.GET_APPL_TYPE !== 'parLeave'
        ) {
          alert('기신청일수가 신청가능일을 초과 하였습니다');
          this.OFF_APP_SPINNER();
          return;
        } else {
          this.nextStepVacation(sYmd);
        }
      }
    },

    // 근태 다음 페이지
    async nextStepVacation(sYmd) {
      if (this.GET_DATE_TYPE === 'OD') {
        if (this.isReward) {
          await this.$store.dispatch('ELA/FETCH_REWARD_HOLI_CNT');
        } else if (this.isVacation) {
          await this.$store.dispatch('ELA/FETCH_HOLI_CNT');
          await this.$store.dispatch('ELA/FETCH_REST_CNT');
        }
        this.$router.push(routerNames.ExtraOptions); // 추가옵션 화면
      } else if (this.GET_DATE_TYPE === 'H') {
        this.SET_APPL_YMD(sYmd);
        this.SET_APPL_YMD_WEEK(dayjs(sYmd).format('ddd')); // 요일
        this.$router.push(routerNames.SelectTime); // 시간선택 화면
      } else {
        //this.$router.push(routerNames.EndDate);
        this.$router.push(routerNames.EndDateAppl); // 종료일자
        this.OFF_APP_SPINNER();
      }
    },
  },
  async mounted() {
    let param = {
          sYmd: dayjs().format('YYYYMMDD'),
    }
    let response = await getRemainDaysBefore(param);


    if (this.GET_APPL_CD === '151') {
      this.$store.commit('SET_REMAIN_DAYS_BEFORE', Number(response.data.data.remainDaysBefore) + Number(this.GET_ADD_LIMIT_TERM));
    }else {
      this.$store.commit('SET_REMAIN_DAYS_BEFORE', parseInt(response.data.data.remainDaysBefore));
    }
    

    if (this.GET_APPL_CD1 === '152') {
      this.$refs.selectDateContentAppl.dates = this.GET_PARLEV_RETURN_YMD;
    }

  },

  destroyed() {
    this.OFF_APP_SPINNER(); // 스피너 OFF
  },
  components: {
    SelectDateHeader,
    SelectDateContentAppl,
    SelectDateTitleLeaAbs,
  },
};
</script>
<style></style>
